import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { createNewsRPMInstanceArticleSlugCollection } from "#root/schema/platform/newsrpm-instance";
import PageLayout from "./layout";

export default function ArticleListPage({ instanceId }): ReactNode {
  const articleCollection = useMemo(() => createNewsRPMInstanceArticleSlugCollection(instanceId), [instanceId]);

  return (
    <PageLayout title="NewsRPM - Instance - Articles">
      <PaginatedList title="Articles" collection={articleCollection} refresh={5000}>
        {({ rows }) => (
          <table className="articles">
            <thead>
            <tr>
              <th>Date</th>
              <th>Provider</th>
              <th>Headline</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, date, headline, provider, slug }) => (
              <tr key={id}>
                <td style={{ whiteSpace: "nowrap" }}>{new Date(date).toLocaleString()}</td>
                <td>{provider}</td>
                <td>
                  <Link to={slug}>{headline}</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
